import React from "react";
import { createRoot } from "react-dom/client";
import { ContextProvider } from "./contexts/ContextProvider";
import { PrimeReactProvider } from "primereact/api";
import "./index.css"; // Your Tailwind CSS file
// import 'bootstrap/dist/css/bootstrap.min.css';

import App from "./App";

// PRIME REACT CSS
import "primereact/resources/themes/lara-light-indigo/theme.css"; // PrimeReact theme
import "primereact/resources/primereact.min.css"; // PrimeReact core styles
import "primeicons/primeicons.css"; // PrimeIcons for icons
import "primeflex/primeflex.css"; // PrimeFlex for layout utilities

// Quill editor styles (bundled with react-quill, used in Form.jsx / Editor.jsx)
import "react-quill/dist/quill.snow.css";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .catch((err) => {
      console.error("Service Worker registration failed:", err);
    });
}
window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  if (
    reason?.name === "ChunkLoadError" ||
    (reason?.message && reason.message.includes("ChunkLoadError"))
  ) {
    console.error("Chunk failed to load. Reloading...");
    window.location.reload();
  }
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <ContextProvider>
        <App />
      </ContextProvider>
    </PrimeReactProvider>
  </React.StrictMode>
);
